import { createTheme  } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';

const Theme = {
  palette: {
    primary: {
      main: '#262773',
      light: '#8381af',
      dark: '#151540',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#00A4E2',
      light: '#7dcaf5',
      dark: '#005b8e',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#D64045',
    },
    warning: {
      main: '#F2B41B',
    },
    success: {
      main: '#5FAB80',
    },
    info: {
      main: '#233B57',
    },
    white: {
      main: '#FFFFFF',
      dark: '#f4f4f4',
      contrastText: '#000',
    },
    darkblue: {
      main: '#262773',
      light: '#8381af',
      ultralight: '#d3d3e2',
      dark: '#151540',
      contrastText: '#FFFFFF',
    },
    blue: {
      main: '#00A4E2',
      light: '#7dcaf5',
      ultralight: '#f2f9fc',
      dark: '#005b8e',
      contrastText: '#FFFFFF',
    },
    green: {
      main: '#a2c617',
      light: '#d0ff1d',
      ultralight: '#faffe6',
      dark: '#789311',
      contrastText: '#FFFFFF',
    },
    pink: {
      main: '#f192aa',
      light: '#ffc7ce',
      ultralight: '#fcf2f4',
      dark: '#be7386',
      contrastText: '#FFFFFF',
    },
    magenta: {
      main: '#e71f67',
      light: '#f573a2',
      ultralight: '#e6ccd5',
      dark: '#b31850',
      contrastText: '#FFFFFF',
    },
    petrolblue: {
      main: '#00566d',
      light: '#5196a8',
      ultralight: '#bfd9e0',
      dark: '#002d39',
      contrastText: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Radikal", Arial, sans-serif',
    htmlFontSize: 16,
    h1: {
      fontFamily: '"Radikal", Arial, sans-serif',
      fontSize: '3rem',
      fontWeight: 700,
      letterSpacing: 0,
      lineHeight: 0.84,
      textTransform: 'uppercase',
    },
    h2: {
      fontFamily: '"Radikal", Arial, sans-serif',
      fontSize: 32,
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: '42px',
      textTransform: 'uppercase',
    },
    h3: {
      fontFamily: '"Radikal", Arial, sans-serif',
      fontSize: 16,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '22px',
      textTransform: 'uppercase',
    },
    h4: {
      fontFamily: '"Radikal", Arial, sans-serif',
      fontSize: 16,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '22px',
    },
    h5: {
      fontFamily: '"Radikal", Arial, sans-serif',
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '22px',
    },
    h6: {
      fontFamily: '"Radikal", Arial, sans-serif',
      fontSize: '1.2rem',
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: 1.25,
    },
    body1: {
      fontFamily: '"Radikal", Arial, sans-serif',
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '22px',
    },
    body2: {
      fontFamily: '"Radikal", Arial, sans-serif',
      fontSize: '1.2rem',
      fontWeight: 100,
      letterSpacing: 0,
      lineHeight: 1.4,
    },
    subtitle1: {
      fontFamily: '"Radikal", Arial, sans-serif',
      fontSize: '1.15rem',
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: 1.4,
    },
    subtitle2: {
      fontFamily: '"Radikal", Arial, sans-serif',
      fontSize: '1rem',
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 1.35,
    },
    button: {
      fontFamily: '"Radikal", Arial, sans-serif',
      fontSize: 15,
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: '29px',
      textTransform: 'uppercase',
    },
    overline: {
      fontFamily: '"Radikal", Arial, sans-serif',
      fontSize: 15,
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '29px',
    },
    caption: {
      fontFamily: '"Radikal", Arial, sans-serif',
      fontSize: '0.9rem',
      fontWeight: 300,
      letterSpacing: 0,
      lineHeight: 1.2857,
    },
  },
  components: {
    MuiChip: {      
      styleOverrides: {
        root: {
          paddingLeft: 12,
        },
      },
    },
    MuiTypography: {
      variants: [
        {
          props: { variant: 'display'},
          style: {            
            display: 'inline-block',
            textTransform: 'capitalize',
            padding: '8px 16px',
            margin: '8px !important',
            backgroundColor: '#4777AE',
            color: '#FFFFFF',
            minWidth: 100,
            textAlign: 'center',
            pointerEvents: 'none',
          },
        },
      ],
    },
  },
};

export default createTheme(Theme, frFR);
